// extracted by mini-css-extract-plugin
export default {"allRunsCheckboxSpacing":"WorkflowDeleteModal_allRunsCheckboxSpacing__AYOXy"};